$('document').ready(function() {


  if($( ".searchCateg" ).length > 0){
    $('.searchCateg').keyup(function() {
      if($('.searchCateg').val().length > 2){
        $('.search-marvel').each(function (e){
          var slug = $(this).data('slug');
          if(slug.toLowerCase().search($('.searchCateg').val().toLowerCase()) < 0){
            $(this).addClass('d-none-imp')
          }else{
            $(this).removeClass('d-none-imp')
          }
        })
      }else{
        if ($('.searchCateg').val().length == 0){
          $('.search-marvel').each(function (e){
            $(this).removeClass('d-none-imp')
          })
        }
      }
    });
  }

  if ($('#js-responsive-menu').length > 0) {
    var $menu = $('#js-responsive-menu').mmenu({
      navbar: {
        add: true,
        title: 'Menu',
      },
      navbars: [{
        position: 'top',
      }],
      'extensions': [
        'position-right',
      ],
    }, {
      offCanvas: {
        pageSelector: '#main-content',
      },
    })

    var $mmenuIcon = $('.js-burger-nav-button')
    var $mmenuAPI = $menu.data('mmenu')

    $mmenuIcon.on('click', function() {
      if ($('html').hasClass('mm-wrapper_opened')) {
        $mmenuAPI.close()
      } else {
        $mmenuAPI.open()
      }
    })

    $mmenuAPI.bind('open:start', function() {
      $mmenuIcon.addClass('js-is-active')
    })
    $mmenuAPI.bind('close:start', function() {
      $mmenuIcon.removeClass('js-is-active')
    })
  }


  if (document.querySelectorAll('.dashboard-header').length > 0) {
    setTimeout(function() {
      let navbar = document.querySelector('.dashboard-header')
      let offsetValue = 150
      let anchorMain = new Headroom(navbar, {
        'offset': offsetValue,
        'tolerance': 0,
        'classes': {
          'initial': 'slide',
          'pinned': 'slide--reset',
          'unpinned': 'slide--up',
        },
      }).init()
    }, 1000)
  }

  function changeCol (oldClass, newClass) {
    $('.replaceClass').each(function(e) {
      if ($(this).hasClass(oldClass)) {
        $(this).toggleClass(oldClass + ' ' + newClass)
      }
    })
  }

  $('.dashboardCollapse').on('hide.bs.collapse', function() {
    $('#accordionPaymoDashboard .dashboard-header').html('')
  })

  $('.dashboardCollapse').on('shown.bs.collapse', function() {
    $($(this).data('menu')).clone().appendTo($('#accordionPaymoDashboard .dashboard-header')).removeClass('d-none')
    $('html, body').animate({scrollTop: 0}, 'fast')
  })


  $('#accordionPaymoDashboard .dashboardCollapse').first().collapse({
    toggle: true,
  })

  if ($('.subtaskCtrl').length > 0) {
    $('.subtaskCtrl').each(function(e) {

      var dateFilter = new Date('2021/11/01').getTime() / 1000
      var dateTask = new Date($(this).data('date')).getTime() / 1000
      if (dateFilter > dateTask) {
        console.log('okkkk')
        $(this).addClass('d-none')
      }
    })
  }

  if ($('#totalPoints').length > 0) {
    var total_point = 0
    $('.checkPoints').each(function(e) {
      var matches = $(this).data('point').match(/\-\s?([0-9]+)\/?([0-9]*?)\s?(pt|point)s?\s?/)
      var pointNumber = 0
      if (matches !== null && matches.length >= 2) {
        pointNumber = matches[1]
        if (matches[2]) {
          pointNumber = parseInt(matches[2]) - parseInt(matches[1])
        }
      }
      $(this).html(pointNumber + ' pts')
      total_point = parseInt(total_point) + parseInt(pointNumber)
    })
    $('#totalPoints').html(total_point + ' pts')

    var total_point_next = 0
    var count_story_next = 0
    $('.wrapper-next .checkPoints').each(function(e) {
      var matches = $(this).data('point').match(/\-\s?([0-9]+)\/?([0-9]*?)\s?(pt|point)s?\s?/)
      var pointNumberNext = 0
      if (matches !== null && matches.length >= 2) {
        pointNumberNext = matches[1]
        if (matches[2]) {
          pointNumberNext = parseInt(matches[2]) - parseInt(matches[1])
        }
      }
      total_point_next = parseInt(total_point_next) + parseInt(pointNumberNext)
      count_story_next = count_story_next + 1
    })
    $('#pointsNext').html(total_point_next + ' pts')
    $('#countNext').html(count_story_next + ' - ')

    var total_point_ip = 0
    var count_story_ip = 0
    $('.wrapper-ip .checkPoints').each(function(e) {
      var matches = $(this).data('point').match(/\-\s?([0-9]+)\/?([0-9]*?)\s?(pt|point)s?\s?/)
      var pointNumberIp = 0
      if (matches !== null && matches.length >= 2) {
        pointNumberIp = matches[1]
        if (matches[2]) {
          pointNumberIp = parseInt(matches[2]) - parseInt(matches[1])
        }
      }
      total_point_ip = parseInt(total_point_ip) + parseInt(pointNumberIp)
      count_story_ip = count_story_ip + 1
    })
    $('#pointsIp').html(total_point_ip + ' pts')
    $('#countIp').html(count_story_ip + ' - ')

    var total_point_wf = 0
    var count_story_wf = 0
    $('.wrapper-wf .checkPoints').each(function(e) {
      var matches = $(this).data('point').match(/\-\s?([0-9]+)\/?([0-9]*?)\s?(pt|point)s?\s?/)
      var pointNumberWf = 0
      if (matches !== null && matches.length >= 2) {
        pointNumberWf = matches[1]
        if (matches[2]) {
          pointNumberWf = parseInt(matches[2]) - parseInt(matches[1])
        }
      }
      // $(this).html(pointNumberWf+' pts');
      total_point_wf = parseInt(total_point_wf) + parseInt(pointNumberWf)
      count_story_wf = count_story_wf + 1
    })
    $('#pointsWf').html(total_point_wf + ' pts')
    $('#countWf').html(count_story_wf + ' - ')

    var total_point_ongoing = 0
    var count_story_ongoing = 0
    $('.wrapper-ongoing .checkPoints').each(function(e) {
      var matches = $(this).data('point').match(/\-\s?([0-9]+)\/?([0-9]*?)\s?(pt|point)s?\s?/)
      var pointNumberOngoing = 0
      if (matches !== null && matches.length >= 2) {
        pointNumberOngoing = parseInt(matches[1])
        if (matches[2]) {
          pointNumberOngoing = parseInt(matches[2]) - parseInt(matches[1])
        }
      }
      total_point_ongoing = parseInt(total_point_ongoing) + parseInt(pointNumberOngoing)
      count_story_ongoing = count_story_ongoing + 1
    })
    $('#pointsOngoing').html(total_point_ongoing + ' pts')
    $('#countOngoing').html(count_story_ongoing + ' - ')
  }

  if ($('#remainingPoints').length > 0) {
    var total_point = 0
    $('.checkPoints').each(function(e) {
      var matches = $(this).data('point').match(/\-\s?([0-9]+)\/?([0-9]*?)\s?(pt|point)s?\s?/)
      var pointNumber = 0
      if (matches !== null && matches.length >= 2) {
        pointNumber = matches[1]
        if (matches[2]) {
          pointNumber = parseInt(matches[2])
        }
      }
      $(this).html(pointNumber + ' pts')
      total_point = parseInt(total_point) + parseInt(pointNumber)
    })
    total_point = parseInt($('#remainingPoints').data('amountsprint')) - parseInt(total_point)
    $('#remainingPoints').html(total_point + ' pts')
  }

  if ($('#STND').length > 0 && $('#GT').length > 0 && $('#other').length > 0) {
    var GT = 0
    var STND = 0
    var other = 0
    $('.checkStandard').each(function(e) {
      if ($(this).html().indexOf('#STND') != -1) {
        STND = STND + 1
      } else if ($(this).html().indexOf('#GT') != -1) {
        GT = GT + 1
      } else {
        other = other + 1
      }
    })
    $('#STND').html(' ' + STND)
    $('#GT').html(' ' + GT)
    $('#other').html(' ' + other)
  }

  if ($('#ptsPerHour').length > 0) {
    var timesheet = 0
    $('.getTs').each(function(e) {
      var ts = Math.round(parseFloat($(this).data('timesheet')))
      timesheet = timesheet + ts
    })
    var total_point = 0
    $('.checkPoints').each(function(e) {
      var matches = $(this).data('point').match(/\-\s?([0-9]+)\/?([0-9]*?)\s?(pt|point)s?\s?/)
      var pointNumber = 0
      if (matches !== null && matches.length >= 2) {
        pointNumber = matches[1]
        if (matches[2]) {
          pointNumber = parseInt(matches[2])
        }
      }
      total_point = parseInt(total_point) + parseInt(pointNumber)
    })
    var ptsperhour = (timesheet * 10) / total_point
    $('#ptsPerHour').html(ptsperhour.toFixed(1) + 'h')
  }

  if ($('#burndownChart').length > 0) {
    var start_date = new Date($('#burndownChart').data('startdate'))
    var amountSprint = parseInt($('#burndownChart').data('amountsprint'))
    var durationSprint = $('#burndownChart').data('durationsprint')
    console.log(durationSprint)
    if (durationSprint == 2) {
      var pointsPerDays = amountSprint / 9
      var incFor = 14
    } else if (durationSprint == 3) {
      var pointsPerDays = amountSprint / 14
      var incFor = 21
    } else if (durationSprint == 4) {
      var pointsPerDays = amountSprint / 19
      var incFor = 28
    } else if (durationSprint == 1) {
      var pointsPerDays = amountSprint / 4
      var incFor = 7
    } else if (durationSprint == 5) {
      var pointsPerDays = amountSprint / 259
      var incFor = 364
    } else {
      var pointsPerDays = amountSprint / 9
      var incFor = 14
    }
    var dateForX = []
    var newdate = ''
    var newdateLabel = ''
    var newdatetime = ''
    var pointsForBurndown = []
    var amountForRythm = amountSprint + pointsPerDays
    for (let i = 0; i < incFor; i++) {
      if (i == 0) {
        newdateLabel = new Date(start_date).toLocaleDateString()
        newdate = new Date(start_date).getDay()
        newdatetime = new Date(start_date).getTime()
      } else {
        newdateLabel = new Date(start_date.setDate(start_date.getDate() + 1)).toLocaleDateString()
        newdate = new Date(start_date).getDay()
        newdatetime = new Date(start_date).getTime()
      }
      if (newdate != 0 && newdate != 6) {
        amountForRythm = amountForRythm - pointsPerDays
        dateForX.push({x: newdateLabel, y: amountForRythm})
      }
      var pointNumber = 0
      $('.checkPoints').each(function(e) {
        if ($(this).data('enddate') == newdateLabel) {
          var matches = $(this).data('point').match(/\-\s?([0-9]+)\/?([0-9]*?)\s?(pt|point)s?\s?/)
          if (matches !== null && matches.length >= 2) {
            if (matches[2]) {
              pointNumber = pointNumber + parseInt(matches[2])
            } else {
              pointNumber = pointNumber + parseInt(matches[1])
            }
          }
        }
      })
      if (newdate != 0 && newdate != 6) {
        amountSprint = amountSprint - pointNumber
        var d1 = newdatetime / 1000
        var d2 = new Date().getTime() / 1000
        if (d1 < d2) {
          pointsForBurndown.push({x: newdateLabel, y: amountSprint})
        }
      }
    }
    var ctx = document.getElementById('burndownChart').getContext('2d')
    const data = {
      // labels: dateForX,
      datasets: [
        {
          label: 'Rythme de croisière',
          data: dateForX,
          borderColor: 'rgb(108, 173, 222)',
        },
        {
          label: 'Points encore à livrer',
          data: pointsForBurndown,
          borderColor: 'rgb(254, 192, 87)',
        },
      ],
    }
    var burndownChart = new Chart(ctx, {
      type: 'line',
      data: data,
      showTooltips: false,
      options: {
        layout: {
          padding: {
            left: 0,
            right: 0,
          },
        },
        responsive: true,
        plugins: {
          legend: {
            position: 'top',
          },
          title: {
            display: false,
          },
        },
      },
    })
  }

  if ($('#chartBudget').length > 0) {

    var projects = $('#chartBudget').data('projects')
    console.log(projects)
    var usPerMonth = {}
    var budget = []
    var moyenneAnnuel = $('#chartBudget').data('moyenneannuel')

    function dateRange (startDate, endDate) {
      var start = startDate.split('-')
      var end = endDate.split('-')
      var startYear = parseInt(start[0])
      var endYear = parseInt(end[0])
      var dates = []
      var monthNames = ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin',
        'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Decembre',
      ]
      for (var i = startYear; i <= endYear; i++) {
        var endMonth = i != endYear ? 11 : parseInt(end[1]) - 1
        var startMon = i === startYear ? parseInt(start[1]) - 1 : 0
        for (var j = startMon; j <= endMonth; j = j > 12 ? j % 12 || 11 : j + 1) {
          var month = j + 1
          var displayMonth = month < 10 ? '0' + month : month
          dates.push(monthNames[displayMonth - 1])
          usPerMonth[i + '-' + displayMonth] = 0
          budget.push(moyenneAnnuel)
        }
      }
      return dates
    }

    var dateStartts = $('#chartBudget').data('start')
    var dateStart_ts_ms = dateStartts * 1000
    var dateStart_ob = new Date(dateStart_ts_ms)
    var dateStart = dateStart_ob.getFullYear() + '-' + ('0' + (dateStart_ob.getMonth() + 1)).slice(-2) + '-' +
      ('0' + dateStart_ob.getDate()).slice(-2)

    var dateEndts = $('#chartBudget').data('end')
    var dateEnd_ts_ms = dateEndts * 1000
    var dateEnd_ob = new Date(dateEnd_ts_ms)
    var dateEnd = dateEnd_ob.getFullYear() + '-' + ('0' + (dateEnd_ob.getMonth() + 1)).slice(-2) + '-' +
      ('0' + dateEnd_ob.getDate()).slice(-2)

    var ArraydateRange = dateRange(dateStart, dateEnd)

    Object.keys(projects).forEach(function(key) {
      var keyArray = projects[key].due_date.substring(0, 7)
      usPerMonth[keyArray] += 1
    })

    console.log(Object.values(usPerMonth))

    const data = {
      labels: ArraydateRange,
      datasets:
        [{
          label: 'Stories réalisées',
          data: Object.values(usPerMonth),
          backgroundColor: 'rgba(254, 192, 87, 0.6)',
          borderColor: 'rgba(254, 192, 87,0.9)',
          borderWidth: 1,
          order: 2,
        },
          {
            type: 'line',
            label: 'Moyenne de stories à réaliser',
            data: budget,
            backgroundColor: 'rgba(255, 255, 255,0)',
            borderColor: 'rgba(254, 192, 87, 0.7)',
            borderWidth: 2,
            order: 1,
          },
        ],
    }

    var ctx = document.getElementById('chartBudget').getContext('2d')
    var burndownChart = new Chart(ctx, {
      type: 'bar',
      data: data,
      showTooltips: false,
      options: {
        scales: {
          y: {
            beginAtZero: true,
            //min:0,
            //max:10
          },
        },
        responsive: true,
        plugins: {
          legend: {
            position: 'top',
          },
        },
      },
    })
  }

  function compare (a, b) {
    var comparison = 0

    if (parseInt(a.count) > parseInt(b.count)) {
      comparison = 1
    } else if (parseInt(b.count) > parseInt(a.count)) {
      comparison = -1
    }
    return comparison
  }

  function parseDate (str) {
    var mdy = str.split('-')
    return new Date(mdy[0], mdy[1] - 1, mdy[2])
  }

  function datediff (first, second) {
    // Take the difference between the dates and divide by milliseconds per day.
    // Round to nearest whole number to deal with DST.
    return Math.round((second - first) / (1000 * 60 * 60 * 24))
  }

  if ($('.checkBudget').length > 0) {
    $('.checkBudget').each(function(e) {
      var now = new Date()
      var today = now.getFullYear() + '-' + ('0' + (now.getMonth() + 1)).slice(-2) + '-' +
        ('0' + (now.getDate() + 1)).slice(-2)
      var currentDaysPassed = datediff(parseDate($(this).data('start')), parseDate(today))
      var daysInTheProject = datediff(parseDate($(this).data('start')), parseDate($(this).data('end')))
      var timePercent = ((currentDaysPassed / daysInTheProject) * 100).toFixed(0)
      var budgetHoursUsed = $(this).data('timesheet') / 60 / 60
      var budgetHoursPercent = ((budgetHoursUsed / $(this).data('budget')) * 100).toFixed(0)
      var diffHours = budgetHoursPercent - timePercent

      var message = ''
      if (timePercent > 100) {
        message = '<div class="alerte-conso"><i class="fal fa-file-signature"></i> Fin de contrat :' +
          $(this).data('end') + '</div>'
      } else if (diffHours >= 25) {
        message = '<div class="alerte-conso red"><i class="fas fa-siren-on"></i> +' + Math.abs(diffHours) +
          '% en surconsommation (en heure)</div>'
      } else if (diffHours >= 10) {
        message = '<div class="alerte-conso orange d-none"><i class="fas fa-siren-on"></i> +' + Math.abs(diffHours) +
          '% en surconsommation (en heure)</div>'
      } else if (diffHours >= 0) {
        message = '<div class="alerte-conso green d-none"><i class="fas fa-thumbs-up"></i> +' + Math.abs(diffHours) +
          '% en surconsommation (en heure)</div>'
      } else if (diffHours < 0 && diffHours > -10) {
        message = '<div class="alerte-conso green d-none"><i class="fas fa-thumbs-up"></i> -' + Math.abs(diffHours) +
          '% en sous-consommation (en heure)</div>'
      } else if (diffHours <= -25) {
        message = '<div class="alerte-conso red"><i class="fas fa-siren-on"></i> -' + Math.abs(diffHours) +
          '% en sous-consommation (en heure)</div>'
      } else if (diffHours <= -10) {
        message = '<div class="alerte-conso orange d-none"><i class="fas fa-siren-on"></i> -' + Math.abs(diffHours) +
          '% en sous-consommation (en heure)</div>'
      } else {
        message = '<div class="conso d-none"><i class="fas fa-thumbs-up"></i></div>'
      }
      $(this).append(message)
    })
  }

  if ($('.complete-task-check').length > 0) {
    $('.complete-task-check').each(function(e) {

      var now = new Date()
      var today = now.getFullYear() + '-' + ('0' + (now.getMonth() + 1)).slice(-2) + '-' +
        ('0' + (now.getDate() + 1)).slice(-2)
      var currentDaysPassed = datediff(parseDate($(this).data('start')), parseDate(today))
      var daysInTheProject = datediff(parseDate($(this).data('start')), parseDate($(this).data('end')))
      var timePercent = ((currentDaysPassed / daysInTheProject) * 100).toFixed(0)
      var budgetPoints = $(this).data('budget') / 0.4
      var pointsUsed = 0
      $('.controle-done', this).each(function(e) {
        var matches = $(this).data('task').match(/\-\s?([0-9]+)\/?([0-9]*?)\s?(pt|point)s?\s?/)
        var pointNumber = 0
        if (matches !== null && matches.length >= 2) {
          pointNumber = matches[1]
          if (matches[2]) {
            pointNumber = parseInt(matches[2])
          }
        }
        pointsUsed = parseInt(pointsUsed) + parseInt(pointNumber)
      })

      // $(this).data('points',pointsUsed);

      var budgetPointsPercent = ((pointsUsed / budgetPoints) * 100).toFixed(0)
      var diffPoints = budgetPointsPercent - timePercent

      console.log($(this).parent().parent().find('h3').html())
      // console.log(pointsUsed)
      // console.log(budgetPoints)
      // console.log(budgetPointsPercent)
      // console.log(timePercent)
      // console.log(diffPoints)
      // console.log(timePercent)


      var message = ''
      if (timePercent > 100) {
        message = ''
      } else if (diffPoints >= 25) {
        message = '<div class="alerte-conso red"><i class="fas fa-siren-on"></i> +' + Math.abs(diffPoints) +
          '% en surconsommation (en point)</div>'
      } else if (diffPoints >= 10) {
        message = '<div class="alerte-conso orange d-none"><i class="fas fa-siren-on"></i> +' + Math.abs(diffPoints) +
          '% en surconsommation (en point)</div>'
      } else if (diffPoints >= 0) {
        message = '<div class="alerte-conso green d-none"><i class="fas fa-thumbs-up"></i> +' + Math.abs(diffPoints) +
          '% en surconsommation (en point)</div>'
      } else if (diffPoints < 0 && diffPoints > -10) {
        message = '<div class="alerte-conso green d-none"><i class="fas fa-thumbs-up"></i> -' + Math.abs(diffPoints) +
          '% en sous-consommation (en point)</div>'
      } else if (diffPoints <= -25) {
        message = '<div class="alerte-conso red"><i class="fas fa-siren-on"></i> -' + Math.abs(diffPoints) +
          '% en sous-consommation (en point)</div>'
      } else if (diffPoints <= -10) {
        message = '<div class="alerte-conso orange d-none"><i class="fas fa-siren-on"></i> -' + Math.abs(diffPoints) +
          '% en sous-consommation (en point)</div>'
      } else {
        message = '<div class="conso d-none"><i class="fas fa-thumbs-up"></i></div>'
      }
      $(this).append(message)
    })
  }

  // if($('.count-next').length > 0){
  //   var pointsInNext = 0;
  //   $('.count-next').each(function (e){
  //     var matches = $(this).data('points').match(/\-\s?([0-9]+)\/?([0-9]*?)\s?(pt|point)s?\s?/);
  //     var pointNumber = 0;
  //     if (matches !== null && matches.length >= 2) {
  //       pointNumber = matches[1];
  //       if(matches[2]){
  //         pointNumber = parseInt(matches[2]);
  //       }
  //     }
  //     pointsInNext = parseInt(pointsInNext) + parseInt(pointNumber);
  //   });
  //   var counterNext = ' ('+pointsInNext+' pts';
  //   $('#counterHeaderNext').append(counterNext)
  //   if(pointsInNext > 2000){
  //     $('#counterHeaderNext').addClass('color-red');
  //   }
  // }

  var pointsByStatus = {}

  $('.task').each(function() {
    console.log($(this).data('status'))
    console.log(parseInt($(this).data('points')))
    var status = $(this).data('status')
    var points = parseInt($(this).data('points'))
    if (!pointsByStatus[status]) {
      pointsByStatus[status] = points || 0
    } else {
      pointsByStatus[status] += points || 0
    }
  })
  console.log(pointsByStatus)

  $('#counterHeaderTop').append('<br />' + (pointsByStatus['top of the backlog'] || 0) + ' pts')
  $('#counterHeaderNext').append('<br />' + (pointsByStatus['next'] || 0) + ' pts')
  $('#counterHeaderWaitingFor').append('<br />' + (pointsByStatus['waiting for client'] || 0) + ' pts')
  $('#counterHeaderInProgress').append('<br />' + (pointsByStatus['in progress'] || 0) + ' pts')
  $('#counterHeaderOnGoing').append('<br />' + (pointsByStatus['ongoing'] || 0) + ' pts')
  $('#counterHeaderInternalCheck').append('<br />' + (pointsByStatus['ready for review'] || 0) + ' pts')
  $('#counterHeaderLearn').append('<br />' + (pointsByStatus['learn'] || 0) + ' pts')


  if ($('#counterHeaderIP').length > 0) {
    if ($('#counterHeaderIP').data('ip') > 30) {
      $('#counterHeaderIP').addClass('color-red')
    }
  }

  if ($('#burndownChartSprint').length > 0) {
    var arraySprint = []
    var average = []
    $('.burdown-sprint').each(function(e) {
      if ($(this).data('label') && $(this).data('points')) {
        arraySprint.push({x: $(this).data('end'), y: $(this).data('points')})
        average.push($(this).data('average'))
      }
    })

    var ctx = document.getElementById('burndownChartSprint').getContext('2d')
    const data = {
      datasets: [
        {
          label: 'Points par sprint',
          data: arraySprint,
          backgroundColor: 'rgba(254, 192, 87,0.8)',
          borderColor: 'rgba(0, 0, 0,0.4)',
          order: 2,
        },
        {
          type: 'line',
          label: 'Moyenne de points à réaliser',
          data: average,
          backgroundColor: '#7b868c',
          borderColor: '#7b868c',
          borderWidth: 2,
          order: 1,
        },
      ],
    }
    var burndownChart = new Chart(ctx, {
      type: 'bar',
      data: data,
      showTooltips: false,
      options: {
        layout: {
          padding: {
            left: 0,
            right: 0,
          },
        },
        responsive: true,
        plugins: {
          legend: {
            position: 'top',
          },
          title: {
            display: false,
          },
        },
      },
    })
  }

  if ($('.tasks-burndown')) {
    var totalDM = 0;
    var totalWA = 0;
    var totalNone = 0;
    var totalOther = 0;
    var totalSupport = 0;
    var totalJPMax = 0;
    var totalLiliant = 0;
    var totalPts = 0;

    var tsJpMax = 0;
    var tsLiliant = 0;
    var tsSupport = 0;
    var tsOther = 0;
    var tsTotal = 0;

    $('.task-burndown').each(function() {
      var points = parseInt(/^.*- ? ?([0-9]+) ? ?(pt|point)s ?-.*$/.test( $(this).data('name'))
        ? $(this).data('name').replace(/^.*- ? ?([0-9]+) ? ?(pt|point)s ?-.*$/, '$1') : 0);
      var isDM = $(this).data('name').match(/(?:\W|^)(#DM)(?:\W|$)/) || $(this).data('name').match(/(?:\W|^)(#OM)(?:\W|$)/);
      var isWA = $(this).data('name').match(/(?:\W|^)(#WA)(?:\W|$)/);
      if (isDM) {
        totalDM += points
      }
      if (isWA) {
        totalWA += points
      }
      if (!isWA && !isDM) {
        totalNone += points
        // $(this).addClass('bg-no-tag')
      }
      if (isWA && isDM) {
        // BOTH
        totalWA -= points/2
        totalDM -= points/2
      }

      var timesheet = Math.round(parseFloat($(this).find('.getTs').data('timesheet')));

      var liliant = $(this).data('manager') == 'liliant';
      var jpmax = $(this).data('manager') == 'jpmax';
      var support = $(this).data('manager') == 'support';
      var other = $(this).data('manager') == 'other';
      totalPts += points
      tsTotal += timesheet
      if (liliant) {
        totalLiliant += points
        tsLiliant += timesheet
      }
      if (jpmax) {
          totalJPMax += points
          tsJpMax += timesheet
      }
      if (support) {
          totalSupport += points
          tsSupport += timesheet
      }
      if (other) {
          totalOther += points
          tsOther += timesheet
        $(this).addClass('bg-no-tag')
      }

      // $('.getTs').each(function(e) {
      //   var ts = Math.round(parseFloat($(this).data('timesheet')))
      //   timesheet = timesheet + ts
      // })
      // var total_point = 0
      // $('.checkPoints').each(function(e) {
      //   var matches = $(this).data('point').match(/\-\s?([0-9]+)\/?([0-9]*?)\s?(pt|point)s?\s?/)
      //   var pointNumber = 0
      //   if (matches !== null && matches.length >= 2) {
      //     pointNumber = matches[1]
      //     if (matches[2]) {
      //       pointNumber = parseInt(matches[2])
      //     }
      //   }
      //   total_point = parseInt(total_point) + parseInt(pointNumber)
      // })
      // var ptsperhour = (timesheet * 10) / total_point
      // $('#ptsPerHour').html(ptsperhour.toFixed(1) + 'h')
    });

    var ptsperhourJPMax = tsJpMax > 0 ? (tsJpMax * 10) / totalJPMax : '-'
    var ptsperhourLiliant = tsLiliant > 0 ? (tsLiliant * 10) / totalLiliant : '-'
    var ptsperhourSupport = tsSupport > 0 ? (tsSupport * 10) / totalSupport : '-'
    var ptsperhourOther = tsOther > 0 ? (tsOther * 10) / totalOther : '-'
    var ptsperhourTotal = tsTotal > 0 ? (tsTotal * 10) / totalPts : '-'

    $('#tasks-burndown-dm-total').html(totalDM + ' pts');
    $('#tasks-burndown-wa-total').html(totalWA + ' pts');
    $('#tasks-burndown-none-total').html(totalNone + ' pts');
    $('#tasks-burndown-liliant-total').html(totalLiliant + ' pts');
    $('#tasks-burndown-jpmax-total').html(totalJPMax + ' pts');
    $('#tasks-burndown-support-total').html(totalSupport + ' pts');
    $('#tasks-burndown-other-total').html(totalOther + ' pts');
    $('#tasks-burndown-total').html(totalPts + ' pts');

    $('#tasks-burndown-liliant-ts').html(tsLiliant + ' h');
    $('#tasks-burndown-jpmax-ts').html(tsJpMax + ' h');
    $('#tasks-burndown-support-ts').html(tsSupport + ' h');
    $('#tasks-burndown-other-ts').html(tsOther + ' h');
    $('#tasks-burndown-total-ts').html(tsTotal + ' h');

    $('#tasks-burndown-liliant-ratio').html(ptsperhourLiliant == '-' ? '-' : ptsperhourLiliant.toFixed(1) + ' h');
    $('#tasks-burndown-jpmax-ratio').html(ptsperhourJPMax == '-' ? '-' : ptsperhourJPMax.toFixed(1) + ' h');
    $('#tasks-burndown-support-ratio').html(ptsperhourSupport == '-' ? '-' : ptsperhourSupport.toFixed(1) + ' h');
    $('#tasks-burndown-other-ratio').html(ptsperhourOther == '-' ? '-' : ptsperhourOther.toFixed(1) + ' h');
    $('#tasks-burndown-total-ratio').html(ptsperhourTotal == '-' ? '-' : ptsperhourTotal.toFixed(1) + ' h');

  }

  if ($('#allStats').length > 0) {

    let users = {}
    var maxUserPoints = 500;
    var maxManagerPoints = 500;
    var maxTagPoints = 0;
    var tags = {}
    $('.data[data-user]').each(function() {
      // var points = parseInt($(this).data('points')) || 0
      var points = parseInt(/^.*- ? ?([0-9]+) ? ?(pt|point)s ?-.*$/.test( $(this).data('name'))
        ? $(this).data('name').replace(/^.*- ? ?([0-9]+) ? ?(pt|point)s ?-.*$/, '$1') : 0);

      var isDM = $(this).data('name').match(/(?:\W|^)(#DM)(?:\W|$)/) || $(this).data('name').match(/(?:\W|^)(#OM)(?:\W|$)/);
      var isWA = $(this).data('name').match(/(?:\W|^)(#WA)(?:\W|$)/);
      var isNone = !isDM && !isWA
      var tag = isDM ? 'DM' : (isWA ? 'WA' : 'none');

      if (!users[$(this).data('user')]) {
        users[$(this).data('user')] = {
          totalProd: 0,
          totalBacklog: 0,
          tasksInProduction: [],
          tasksRequested: [],
          tasksLearn: [],
          tasksTopBacklog: [],
          backlog: []}
      }

      var pushIn = 'backlog'
      var color = 'white'
      switch ($(this).data('status')) {
        case 'next' :
        case 'waiting for client' :
          pushIn = 'tasksRequested'; users[$(this).data('user')].totalProd += points; users[$(this).data('user')].totalBacklog += points; color = 'bg-blue1'; break
        case 'in progress' :
        case 'ongoing' :
        case 'internal check' :
          pushIn = 'tasksInProduction'; users[$(this).data('user')].totalProd += points; users[$(this).data('user')].totalBacklog += points; color = 'bg-orange1'; break
        case 'learn' :
          pushIn = 'tasksLearn'; users[$(this).data('user')].totalProd += points; users[$(this).data('user')].totalBacklog += points; color = 'bg-red1'; break
        case 'top of the backlog' :
          pushIn = 'tasksTopBacklog'; users[$(this).data('user')].totalBacklog += points; color = 'bg-black1'; break
        default :
      }

      if ($(this).data('type') === 'user') {
        maxUserPoints = Math.max(maxUserPoints, users[$(this).data('user')].totalProd)
      } else {
        maxManagerPoints = Math.max(maxManagerPoints, users[$(this).data('user')].totalBacklog)
      }

      if ($(this).data('type') === 'manager') {
        if (!tags[tag]) {
          tags[tag] = {
            total: 0,
            tasksInProduction: [],
            tasksRequested: [],
            tasksLearn: [],
            tasksTopBacklog: [],
            backlog: []
          }
        }
        if (['tasksRequested', 'tasksInProduction', 'tasksLearn'].indexOf(pushIn)>=0) {
          tags[tag].total += points
          tags[tag][pushIn].push({
            name: $(this).data('name'),
            points: points,
            color : color,
            id: $(this).data('id')
          })
          maxTagPoints = Math.max(maxTagPoints, tags[tag].total)
        }
      }

      users[$(this).data('user')][pushIn].push({
        name: $(this).data('name'),
        id: $(this).data('id'),
        points: points,
      })
    })
    // console.log(users, 'maxPoints : ', maxUserPoints, maxManagerPoints)

    console.log(tags, maxTagPoints)

    for(var tag in tags) {
      $('.data-total-points-tag[data-tag='+tag+']').append('<h3 data-toggle="tooltip" data-placement="top" title="Next + Waiting for + In progress + OnGoing + Internal check">'+ (tags[tag].total) + ' pts</h3>')
      for(var task of tags[tag].tasksInProduction) {
        var percentage = (task.points / maxTagPoints) * 100
        $('.progress[data-tag='+tag+']').append('<a href="https://app.paymoapp.com/#Paymo.Home/AllTasks/board/task/'+task.id+'" target="_blank" class="progress-bar '+task.color+'" role="progressbar" style="width: '+percentage+'%" data-toggle="tooltip" data-placement="top" title="'+ task.name +'"></a>')
      }
      for(var task of tags[tag].tasksRequested) {
        var percentage = (task.points / maxTagPoints) * 100
        $('.progress[data-tag='+tag+']').append('<a href="https://app.paymoapp.com/#Paymo.Home/AllTasks/board/task/'+task.id+'" target="_blank" class="progress-bar '+task.color+'" role="progressbar" style="width: '+percentage+'%" data-toggle="tooltip" data-placement="top" title="'+ task.name +'"></a>')
      }
    }

    for(var userId of Object.keys(users)) {
      var user = users[userId]

      $('.data-total-points-prod[data-user='+userId+']').append('<h3 data-toggle="tooltip" data-placement="top" title="Next + Waiting for + In progress + OnGoing + Internal check + Learn">'+ (user.totalProd) + ' pts</h3>')
      $('.data-total-points-manager[data-user='+userId+']').append('<h3 data-toggle="tooltip" data-placement="top" title="Next + Waiting for + In progress + OnGoing + Internal check + Learn + Top of the backlog">'+ (user.totalBacklog) + ' pts</h3>')

      for (let task of user.tasksInProduction) {
        if (task.points && task.points>0) {
          var percentage = (task.points / maxUserPoints) * 100
          $('.progress[data-user='+userId+']').append('<a href="https://app.paymoapp.com/#Paymo.Home/AllTasks/board/task/'+task.id+'" target="_blank" class="progress-bar bg-orange1" role="progressbar" style="width: '+percentage+'%" data-toggle="tooltip" data-placement="top" title="'+ task.name +'"></a>')

          var percentage = (task.points / maxManagerPoints) * 100
          $('.progress[data-manager='+userId+']').append('<a href="https://app.paymoapp.com/#Paymo.Home/AllTasks/board/task/'+task.id+'" target="_blank" class="progress-bar bg-orange1" role="progressbar" style="width: '+percentage+'%" data-toggle="tooltip" data-placement="top" title="'+ task.name +'"></a>')
        }
      }
      for (let task of user.tasksRequested) {
        if (task.points && task.points>0) {
          var percentage = (task.points / maxUserPoints) * 100
          $('.progress[data-user='+userId+']').append('<a href="https://app.paymoapp.com/#Paymo.Home/AllTasks/board/task/'+task.id+'" target="_blank" class="progress-bar bg-blue1" role="progressbar" style="width: '+percentage+'%" data-toggle="tooltip" data-placement="top" title="'+ task.name +'"></a>')

          var percentage = (task.points / maxManagerPoints) * 100
          $('.progress[data-manager='+userId+']').append('<a href="https://app.paymoapp.com/#Paymo.Home/AllTasks/board/task/'+task.id+'" target="_blank" class="progress-bar bg-blue1" role="progressbar" style="width: '+percentage+'%" data-toggle="tooltip" data-placement="top" title="'+ task.name +'"></a>')
        }
      }
      for (let task of user.tasksLearn) {
        if (task.points && task.points>0) {
          var percentage = (task.points / maxUserPoints) * 100
          $('.progress[data-user='+userId+']').append('<a href="https://app.paymoapp.com/#Paymo.Home/AllTasks/board/task/'+task.id+'" target="_blank" class="progress-bar bg-red1" role="progressbar" style="width: '+percentage+'%" data-toggle="tooltip" data-placement="top" title="'+ task.name +'"></a>')

          var percentage = (task.points / maxManagerPoints) * 100
          $('.progress[data-manager='+userId+']').append('<a href="https://app.paymoapp.com/#Paymo.Home/AllTasks/board/task/'+task.id+'" target="_blank" class="progress-bar bg-red1" role="progressbar" style="width: '+percentage+'%" data-toggle="tooltip" data-placement="top" title="'+ task.name +'"></a>')
        }
      }
      for (let task of user.tasksTopBacklog) {
        if (task.points && task.points>0) {
          var percentage = (task.points / maxManagerPoints) * 100
          $('.progress[data-manager='+userId+']').append('<a href="https://app.paymoapp.com/#Paymo.Home/AllTasks/board/task/'+task.id+'" target="_blank" class="progress-bar bg-black1" role="progressbar" style="width: '+percentage+'%" data-toggle="tooltip" data-placement="top" title="'+ task.name +'"></a>')
        }
      }
    }
  }

  $(function () {
    $('[data-toggle="tooltip"]').tooltip()
  })



  if ($('#allStatsDone').length > 0) {

    let users = {}
    var maxUserPoints = 500;
    var maxGlobalPoints = 500;
    var globalStatsBySprint = {}
    $('.data').each(function() {
      // var points = parseInt($(this).data('points')) || 0
      var points = parseInt(/^.*- ? ?([0-9]+) ? ?(pt|point)s ?-.*$/.test( $(this).data('name'))
        ? $(this).data('name').replace(/^.*- ? ?([0-9]+) ? ?(pt|point)s ?-.*$/, '$1') : 0);
      if (!users[$(this).data('user')]) {
        users[$(this).data('user')] = {
          // totalDone: 0,
          tasksDoneBySprint: {},
        }
      }

      var isDM = $(this).data('name').match(/(?:\W|^)(#DM)(?:\W|$)/) || $(this).data('name').match(/(?:\W|^)(#OM)(?:\W|$)/);
      var isWA = $(this).data('name').match(/(?:\W|^)(#WA)(?:\W|$)/);
      var isNone = !isDM && !isWA

      // var sprint = Math.floor(((parseInt($(this).data('daynumber'))-12)/14)+2)
      var sprint = parseInt($(this).data('month'))

      console.log($(this).data('duedate'), $(this).data('daynumber'), sprint, '---');
      if (!users[$(this).data('user')].tasksDoneBySprint[sprint]) {
        users[$(this).data('user')].tasksDoneBySprint[sprint] = {
          totalDone: 0,
          tasks:[]
        }
      }
      if (!globalStatsBySprint[sprint]) {
        globalStatsBySprint[sprint] = {
          totalDone: 0,
          count:0,
          tasks:[],
          totalWA: 0,
          totalOM: 0,
          totalNone: 0,
        }
      }

      users[$(this).data('user')].tasksDoneBySprint[sprint].totalDone += points;
      globalStatsBySprint[sprint].totalDone += points;
      globalStatsBySprint[sprint].totalWA += isWA ? points : 0;
      globalStatsBySprint[sprint].totalOM += isDM ? points : 0;
      globalStatsBySprint[sprint].totalNone += isNone ? points : 0;
      globalStatsBySprint[sprint].count += 1;
      if (isDM && isWA) {
        globalStatsBySprint[sprint].totalWA -= points / 2;
        globalStatsBySprint[sprint].totalOM -= points / 2;
      }

      maxUserPoints = Math.max(maxUserPoints, users[$(this).data('user')].tasksDoneBySprint[sprint].totalDone)
      maxGlobalPoints = Math.max(maxGlobalPoints, globalStatsBySprint[sprint].totalDone)


      users[$(this).data('user')].tasksDoneBySprint[sprint].tasks.push({
        name: $(this).data('name').replace(/\"/g,''),
        id: $(this).data('id'),
        points: points,
        date: $(this).data('duedate')
      })

      globalStatsBySprint[sprint].tasks.push({
        name: $(this).data('name').replace(/\"/g,''),
        id: $(this).data('id'),
        points: points,
        date: $(this).data('duedate')
      })
    })

    console.log(users, globalStatsBySprint)

    var oldAverage = 0;
    for(var sprint of Object.keys(globalStatsBySprint)) {
      if (sprint <= 17) {
        oldAverage +=  globalStatsBySprint[sprint].totalDone;
      }
    }
    oldAverage = oldAverage / 17;
    console.log(oldAverage)

    for(var sprint of Object.keys(globalStatsBySprint)) {

      var sprintData = globalStatsBySprint[sprint]
      if (sprint > 17) {
        var progress = Math.round(((sprintData.totalDone / oldAverage) * 100) -100)
        $('.stats-global[data-sprint='+sprint+'] .total-points').append( (sprintData.totalDone) + ' (' + (progress>0 ? '+' : '') + progress + '%)')
        $('.stats-global[data-sprint='+sprint+'] .total-points-om').append( (sprintData.totalOM) + '')
        $('.stats-global[data-sprint='+sprint+'] .total-points-wa').append( (sprintData.totalWA) + '')
        $('.stats-global[data-sprint='+sprint+'] .total-points-none').append( (sprintData.totalNone) + '')
      } else (
        $('.stats-global[data-sprint='+sprint+'] .total-points').append( (sprintData.totalDone) + '')
      )
      $('.stats-global[data-sprint='+sprint+'] .total-count').append( (sprintData.count) + '')

      for (let task of sprintData.tasks) {
        if (task.points && task.points>0) {
          var percentage = (task.points / maxGlobalPoints) * 100
          $('.stats-global[data-sprint='+sprint+'] .progress')
          .append('<a href="https://app.paymoapp.com/#Paymo.Home/AllTasks/board/task/'+task.id+'" target="_blank" class="progress-bar bg-red1" role="progressbar" style="width: '+percentage+'%" data-toggle="tooltip" data-placement="top" title="'+ (task.name + ' / ' + task.date) +'"></a>')
        }
      }
    }


    for(var userId of Object.keys(users)) {
      var user = users[userId]
      for(var sprint of Object.keys(user.tasksDoneBySprint)) {
        var sprintData = user.tasksDoneBySprint[sprint]
        $('[data-user='+userId+'][data-sprint='+sprint+'] .total-points').append( (sprintData.totalDone) + ' pts')

        for (let task of sprintData.tasks) {
          if (task.points && task.points>0) {
            var percentage = (task.points / maxUserPoints) * 100
            $('[data-user='+userId+'][data-sprint='+sprint+'] .progress')
            .append('<a href="https://app.paymoapp.com/#Paymo.Home/AllTasks/board/task/'+task.id+'" target="_blank" class="progress-bar bg-red1" role="progressbar" style="width: '+percentage+'%" data-toggle="tooltip" data-placement="top" title="'+ (task.name + ' / ' + task.date) +'"></a>')
          }
        }
      }
    }
  }

})
